module.exports = "<app-aside-nav style=\"overflow: scroll\"></app-aside-nav>\n<router-outlet></router-outlet>\n"